import React from "react";
import { ChevronRight } from 'lucide-react';

interface ComponentProps {
  title: string;
  icon: JSX.Element; 
  screenName: string; 
  state: boolean;
}

interface SidebarListProps {
  items: ComponentProps[];
  title: string;
  onItemClick: (screenName: string) => void; 
  activeTab: string; // current path
}

export const Sidebarlist: React.FC<SidebarListProps> = ({ items, title, onItemClick, activeTab }) => {

  const handleTabClick = (screenName: string) => {
    onItemClick(screenName); 
  };
  
  return (
    <div className="w-full bg-transparent">
      {title && (
        <div className="px-6 py-2">
          <span className="text-xs font-semibold text-gray-500 uppercase tracking-wider">
            {title}
          </span>
        </div>
      )}
      <div className="space-y-3 px-3">
        {items.map((item, index) => (
          <div
            key={index}
            onClick={() => item.state && handleTabClick(item.screenName)}
            className={`
              group h-12 text-[15px] font-semibold px-3 flex items-center rounded-md transition-colors 
              ${activeTab === item.screenName || (item.screenName !== '/' && activeTab.startsWith(item.screenName))
                ? 'bg-white text-gray-900' 
                : 'text-gray-700 hover:bg-white hover:text-gray-900 '
              }
              ${item.state ? 'cursor-pointer' : 'cursor-not-allowed opacity-50'}
            `}
          >
            <div className={`mr-5 ml-1 flex items-center ${activeTab === item.screenName || (item.screenName !== '/' && activeTab.startsWith(item.screenName)) ? 'text-gray-900' : 'text-gray-700'}`}>
              {item.icon}
            </div>
            <span className="flex-1">{item.title}</span>
            {activeTab === item.screenName || (item.screenName !== '/' && activeTab.startsWith(item.screenName)) && (
              <ChevronRight className="w-4 h-4  ml-auto text-brand" />
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
